import React, { useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  IconButton,
  Box,
} from "@material-ui/core";
// import List from "@mui/material/List";
import { List, ListItem } from "@material-ui/core";
import Heading from "../../../../StyledComponents/Heading/Heading";
import { Close } from "@material-ui/icons";
// import ListItem from "@mui/material/ListItem";
const InvoiceGuideLine = ({ open, close }) => {
  const Paddingstyle = {
    paddingBottom: '10px'
  }
  return (
    <Dialog sx={{marginBotton:'10px'}}
      open={open}
      onClose={() => close(false)}
      scroll="paper"
    // sx={{ width: "60%" }}
    // fullWidth={true}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "20px",
        }}
      >
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} ><Heading title=" General Invoice Guidelines"></Heading></Box>
          <Box>
            <IconButton onClick={() => close(false)}>
              <Close />
            </IconButton>
          </Box>
        </Box>


      </DialogTitle>
      <DialogContent
        sx={{ color: "gray", fontFamily: "Mulish", fontStyle: "normal" }}
      >
        <Typography variant="h6" style={Paddingstyle}>
          1. Only Commercial invoice/ Bill/ Invoice/ Sales Tax invoice is valid
          for payment. Quotations/ Proforma Invoice etc. are only meant for
          documentation purposes and will not be accepted for payment purposes.
        </Typography>
        <Typography variant="h6" style={Paddingstyle} >
          2. Invoice provided for payment must be in the name of
          “FrieslandCampina Engro Pakistan Limited”.
        </Typography>
        <Typography variant="h6" style={Paddingstyle}>
          3. Invoice must bear an invoice # and Date.
        </Typography>
        <Typography variant="h6" style={Paddingstyle}>
          4. Sales tax invoice required if you are registered in sales tax
          authorities.
        </Typography>
        <Typography variant="h6" style={Paddingstyle}>
          5. Sign/stamp on invoice on Original Letter Head or clause be
          mentioned “This is computer/system Generated Invoice hence signature
          not required.”
        </Typography>
        <Typography variant="h6" style={Paddingstyle}>
          6. Invoice number already assigned to an earlier invoice will not
          process unless new/unique invoice number is assigned.
        </Typography>
        <Typography variant="h6" style={Paddingstyle}>
          7. All necessary documents such as Withholding income tax certificate/
          Goods declaration/ Bill of Entry/ Delivery Challans must be attached
          as additional documents.
        </Typography>
        <Typography variant="h6" >
          8. If the invoice number consists of more than 16 digits, then use
          last 16 digits including alpha/numeric and special characters. Special
          characters would be entered same as mentioned on invoice and would not
          be replaced with any other character. Invoice number on Vendor
          Invoice: Ref: FHM/KHI/R-037248/2023 Invoice Number in I2P will be:
          HI/R-037248/2023
        </Typography>
      </DialogContent>

      {/* <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => close(false)}
        >
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default InvoiceGuideLine;
